import React, { useEffect } from "react";
import "./ProcurementDynamicTable.css";
import { useEventEmitter } from "../../contexts/EventEmmiter";
import useIsMobile from "../../hooks/useIsMobile";
import downloadIcon from "../../assets/images/download-icon.svg";

const DynamicTable = ({ data, messageId }) => {
  const { subscribe } = useEventEmitter();
  const isMobile = useIsMobile();

  useEffect(() => {
    const unsubscribe = subscribe("downloadProcurementTableData", (eventMessageId) => {
      if (eventMessageId === messageId) {
        handleTableDataDownload();
      }
    });
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageId]);

  const handleTableDataDownload = () => {
    if (!data || data.length === 0) {
      alert("No data available to download");
      return;
    }

    // Get table headers
    const headers = Object.keys(data[0]);

    // Convert data to CSV format
    const csvRows = [];

    // Add header row
    csvRows.push(headers.map(header => `"${header}"`).join(','));

    // Add data rows
    data.forEach(row => {
      const values = headers.map(header => {
        const value = String(row[header] || '').replace(/"/g, '""'); // Escape quotes
        return `"${value}"`;
      });
      csvRows.push(values.join(','));
    });

    // Create CSV content
    const csvContent = csvRows.join('\n');

    // Create and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'procurement_data.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  if (!data || data.length === 0) return <p>No data available</p>;

  // Get table headers dynamically from first object keys
  const headers = Object.keys(data[0]);

  // Check if table has more than 10 rows to enable scrolling
  const shouldScroll = data.length > 10;

  return (
    <div className={`table-wrapper ${isMobile ? 'mobile' : ''}`}>
      <button
        className="table-download-button"
        onClick={handleTableDataDownload}
        title="Download Table"
      >
        <img src={downloadIcon} alt="Download" className="download-icon" />
      </button>
      <div className={`table-container ${shouldScroll ? 'scrollable' : ''} ${isMobile ? 'mobile' : ''}`}>
        <table className="custom-table">
        <thead>
          <tr>
            <th>#</th>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td>{rowIndex + 1}</td>
              {headers.map((header, colIndex) => (
                <td key={colIndex}>
                  {String(row[header]).replaceAll('"', "")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default DynamicTable;
